import { Button, Container, Dropdown, Input } from '@/components';
import Table from '@/components/common/table/Table';
import { useMarginCalculator } from '@/context/marginCalculatorContext/MarginCalculatorContextProvider';
import React, { useEffect, useState } from 'react';

const MarginCalculatorByProduct = () => {
  const {
    getMainProducts,
    getChildProducts,
    calculateMarginApi,
    marginData,
    setMarginData,
  } = useMarginCalculator();
  const [mainProducts, setMainProducts] = useState([]);
  const [childProducts, setChildProducts] = useState([]);
  const [selectedMainProduct, setSelectedMainProduct] = useState('');
  const [unitPrice, setUnitPrice] = useState('');
  const [conversionFactor, setConversionFactor] = useState('');
  const [seletedchildProducts, setSelectedChildProducts] = useState('');
  const [priceError, setPriceError] = useState('');
  const [childProdError, setChildProdError] = useState('');
  const [mainProdError, setMainProdError] = useState('');

  const disableUnitPrice = [
    '1269-Safety Signs - Self Adhesive Vinyl',
    '1269-Safety Signs - Corflute',
    '1269-Safety Signs - Poly',
    '1269-Safety Signs - Metal',
  ];

  useEffect(() => {
    setMarginData([]);
    const fetchMainProducts = async () => {
      const res = await getMainProducts();
      setMainProducts(res);
    };
    fetchMainProducts();
  }, []);

  useEffect(() => {
    setMarginData([]);
    setUnitPrice('');
    setConversionFactor('');
    setSelectedChildProducts('');
    const fetchChildProducts = async () => {
      if (selectedMainProduct) {
        const res = await getChildProducts(selectedMainProduct);
        const filteredRes = res.filter((product) => product.trim() !== '');
        setChildProducts(filteredRes);
      }
    };
    fetchChildProducts();
  }, [selectedMainProduct]);

  const mainProdOption = mainProducts.map((product) => ({
    label: product,
    value: product,
    data: product,
  }));

  const childProdOption = childProducts.map((product) => ({
    label: product,
    value: product,
    data: product,
  }));

  const handleSubmit = () => {
    setPriceError('');
    setChildProdError('');
    setMainProdError('');
    if (selectedMainProduct === '') {
      setMainProdError('Please select main product');
      return;
    }

    if (childProdOption.length > 0 && seletedchildProducts === '') {
      setChildProdError('Please select child product');
      return;
    }

    calculateMarginApi(
      selectedMainProduct,
      seletedchildProducts,
      unitPrice,
      conversionFactor,
    );
  };

  const columns = [
    { header: 'Major Category', field: 'groupName' },
    { header: 'Minor Category', field: 'childGroup' },
    { header: 'Unit Cost', field: 'cost' },
    { header: 'ABC Class', field: 'abcclass' },
    { header: 'Buyer Planner', field: 'buyerPlanner' },
    {
      header: 'Price Break1',
      render: (row) => (
        <div className="text-center font-500  text-base">
          <div className=" border-b-2 border-black">{row.priceBreak1}</div>
          <div>{row.priceBreak1Percent}%</div>
        </div>
      ),
    },
    { header: 'Qty1', field: 'qty1' },
    {
      header: 'Price Break2',
      render: (row) => (
        <div className="text-center font-500  text-base">
          <div className=" border-b-2 border-black">{row.priceBreak2}</div>
          <div className="">{row.priceBreak2Percent}%</div>
        </div>
      ),
    },
    { header: 'Qty2', field: 'qty2' },
    {
      header: 'Price Break3',
      render: (row) => (
        <div className="text-center font-500  text-base">
          <div className=" border-b-2 border-black">{row.priceBreak3}</div>
          <div className="">{row.priceBreak3Percent}%</div>
        </div>
      ),
    },
    { header: 'Qty3', field: 'qty3' },
    {
      header: 'Price Break4',
      render: (row) => (
        <div className="text-center font-500  text-base">
          <div className=" border-b-2 border-black">{row.priceBreak4}</div>
          <div className="">{row.priceBreak4Percent}%</div>
        </div>
      ),
    },
    {
      header: 'BCC Price',
      render: (row) => (
        <div className="text-center font-500  text-base">
          <div className=" border-b-2 border-black">{row.bccPrice}</div>
          <div className="">{row.bccPriceBreakPercent}%</div>
        </div>
      ),
    },
    { header: 'E4 Price', field: 'e4Price' },
    { header: 'Warehouse', field: 'warehouse' },
    { header: 'Bin Location', field: 'binLocation' },
    { header: 'UNSP', field: 'unsp' },
  ];
  return (
    <Container title="Margin Calculator">
      <div className="grid grid-cols-2 gap-5 m-5">
        <div>
          <Dropdown
            label="Main Products"
            name="mainProducts"
            options={mainProdOption}
            value={selectedMainProduct}
            onChange={(e) => setSelectedMainProduct(e.target.value)}
            required
            error={mainProdError}
          />
        </div>
        <div>
          {childProducts.length > 0 && (
            <Dropdown
              label="Child Products"
              name="childProducts"
              options={childProdOption}
              value={seletedchildProducts}
              onChange={(e) => setSelectedChildProducts(e.target.value)}
              required
              error={childProdError}
            />
          )}
        </div>
        <div>
          <Input
            name="unitPrice"
            label="Unit Price"
            placeholder="Enter Unit Price"
            value={unitPrice}
            onChange={(e) => setUnitPrice(e.target.value)}
            type="number"
            error={priceError}
            disabled={disableUnitPrice.includes(selectedMainProduct)}
          />
        </div>

        <div>
          <Input
            name="conversionFactor"
            label="Conversion Factor"
            value={conversionFactor}
            onChange={(e) => setConversionFactor(e.target.value)}
            placeholder="Enter Conversion Factor"
            type="number"
            errType="valid"
          />
        </div>
      </div>
      <div className="flex justify-center m-5">
        <Button onClick={handleSubmit}>Calculate</Button>
      </div>
      {/* if data length greater than one then only show table */}
      {marginData.length > 0 && <Table columns={columns} data={marginData} />}
    </Container>
  );
};

export default MarginCalculatorByProduct;
